import { SaveButton } from '@/components/refinedev/action_buttons';
import JobForm from './job-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const JobCreate = () => {
  return (
    <CreateForm transformBeforeSave={JobForm.transformBeforeSave}>
      <JobForm />
      <SaveButton/>
    </CreateForm>
  );
};

export default JobCreate;
